import type { ClubParisFields } from '@/modules/cart/domain/Cart';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';

const { CLUB_PARIS_URL } = environment;

export async function postClubParis(
  payload: ClubParisFields
): Promise<{ data: HttpCartDto }> {
  const response = await httpClient.post(CLUB_PARIS_URL, payload);
  return Promise.resolve(response);
}
